import { ReactNode, useContext, useEffect } from 'react'

import { Box, BoxProps } from '@mantine/core'
import { useResizeObserver } from '@mantine/hooks'

import useStyles from './index.styles'
import { AIChatBotContext } from '../../context'

export type ChatBodyProps = {
  action: ReactNode
  actionState?: ReactNode
  scrollToBottom?: boolean
} & BoxProps

export const ChatBody = ({
  action,
  actionState,
  children,
  styles,
  classNames,
  className,
  scrollToBottom,
  ...boxProps
}: ChatBodyProps) => {
  const { expandWidget } = useContext(AIChatBotContext)
  const { classes, cx } = useStyles(
    { expandWidget },
    {
      name: 'AIChatBotWidget__ChatBody',
      styles,
      classNames,
    },
  )

  const [ref, rect] = useResizeObserver()
  useEffect(() => {
    if (scrollToBottom && ref.current) {
      ref.current.scrollTop = ref.current.scrollHeight
    }
  }, [rect.height])

  return (
    <Box className={cx(classes.root, className)} {...boxProps}>
      <Box className={classes.scrollArea}>
        <Box className={classes.scrollBody} ref={ref}>
          {children}
          <div id="anchor"></div>
        </Box>
      </Box>
      <Box className={classes.action}>
        {actionState && <Box>{actionState}</Box>}
        <Box>{action}</Box>
      </Box>
    </Box>
  )
}
